import React, {useState,useEffect,useContext} from "react";
import { useLocation,useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form';
import Lang from '../lang/translations';
import Auth from '../../userServices/authServices';

import Context from '../context/context';


export default function Signup(props) {
    const  context = useContext(Context)

	const [errore, setErrore] = useState("");
	const [source, setSource] = useState("");
	const [spinner, setSpinner] = useState(false);

	const { register, handleSubmit } = useForm();


	const navigate = useNavigate();
 
	var location = useLocation();
	location = location.pathname.split("/")
	
    const onSubmit = (data) => {
		
		setSpinner(true);
		setErrore("");
	
		
		if(source){
			data.source = source;
		}

	

		data.country = localStorage.getItem('country');
		data.city = localStorage.getItem('city');
		data.region = localStorage.getItem('region');
		data.ip = localStorage.getItem('ip');
		data.clickid=localStorage.getItem('trackerId');
		data.fingerprint = localStorage.getItem('fingerprint');
		data.fluxId = context.fluxId;
		data.servizio =  window.location.hostname;
		



            Auth.getTokenForReset(data)
			.then(res => {
				if(res){ 
					setErrore(Lang( {"w": "email_inviata","page": "signupForm"} ));
					setSpinner(false); 
				}else{
					setErrore(Lang( {"w": "utente_inesistente","page": "signupForm"} ));
					setSpinner(false); 
				}
			})
		
		
	};

    useEffect(() => { 

        //form registrazione
       

        var source = localStorage.getItem('source');
        if(source){
            setSource(source);
        }
	
	},[]);


    function Spinner(){
		if(spinner){
			return (<div className="spinner-border text-light" role="status">
		  <span className="sr-only"><Lang w={"caricando"} page={"signupForm"}/></span>
		</div>);
		}else{
			return false;
		}
	}


      return (<div>
        <h4><Lang w={"password_dimenticata"} page={"signupForm"}/></h4>
        <p><Lang w={"introduci_mail_reset_password"} page={"signupForm"}/></p>
        <form className={"formSignup "} onSubmit={handleSubmit(onSubmit)}>
            <input type="email" name="email"  placeholder="Email" required {... register('email',{ required: true }) } ></input>
            <input type="submit" value={Lang( {"w": "invia","page": "signupForm","var":true} )} disabled={spinner}></input>
            {errore && (<p className='erroreSignup'>{errore}</p>)}
            <Spinner/>
            <a onClick={() =>navigate("/login")}><Lang w={"indietro"} page={"signupForm"}/></a>	
        </form></div>);
	
	
}